module.exports = "data:image/svg+xml;base64,PHN2ZyB2aWV3Ym94PSIwIDAgMTggMTgiPgogIDxwYXRoIGNsYXNzPSJxbC1maWxsIiBkPSJNMTMsMTZINWExLDEsMCwwLDEsMC0yaDhBMSwxLDAsMCwxLDEzLDE2WiIvPgogIDxwYXRoIGNsYXNzPSJxbC1maWxsIiBkPSJNMTMsNEg1QTEsMSwwLDAsMSw1LDJoOEExLDEsMCwwLDEsMTMsNFoiLz4KICA8cmVjdCBjbGFzcz0icWwtZmlsbCIgeD0iMiIgeT0iNiIgd2lkdGg9IjE0IiBoZWlnaHQ9IjYiIHJ4PSIxIiByeT0iMSIvPgo8L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./node_modules/quill/assets/icons/float-full.svg
// module id = E93p
// module chunks = 4